<template>
    <div id="ficheFacture">
        <b-row class="backInfoMain2">
            <b-col cols="12">
                <s-menuSave 
                    :btnSaveDisabled="checkAllField" 
                    saveBtn 
                    @save="menuSave()" 
                >
                </s-menuSave>
            </b-col>
        </b-row>
        <invoice :showLeftPanel=false @on-invoice="invoiceChanged" />
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import invoice from '@/components/invoice/invoice/invoice.vue'


export default{
    name: "ficheFacture",
    mixins:[mapGetter],
    components: {
        invoice,
    },
    data() {
        return{
            invoice : {}
        }
    },
    methods: {
        invoiceChanged(params) {
            this.invoice = params.invoice
        },
        menuSave() {
            alert('OK');
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        /**
         * Vérifie s'il ya des modifications
         */
         checkAllField() {
            let countItems = 0
            if(this.invoice?.items) countItems = this.invoice.items.length
           return ((countItems == 0 ) || (Object.keys(this.invoice).length != 5) )
        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {

    },
//------------------------------------------------------------------------------------------------
    watch: {
        
    }
}
</script>

<style lang="scss" scoped>

</style>